import React from "react";
import { Field, reduxForm } from "redux-form";
import ReactMDCheckbox from "../../../common/components/ReactMDCheckbox";
import { Button, CardActions, Divider } from "react-md";

const RangeRentalForm = ({ handleSubmit, invalid, submitting }) => (
  <div>
    <section className="md-grid">
      <h3 className="md-cell md-cell--12">
        Which range(s) will you be using?
      </h3>
      <Field
        id="ranges.pistol"
        name="ranges.pistol"
        label="Handgun"
        component={ReactMDCheckbox}
        value
      />
      <Field
        id="ranges.rifle"
        name="ranges.rifle"
        label="Rifle"
        component={ReactMDCheckbox}
        value
      />
      <p className="md-caption md-cell md-cell--12">
        You must select at least (1).
      </p>
      <Divider />
      <h3 className="md-cell md-cell--12">
        Will you be renting a
        firearm?
      </h3>

      <Field
        id="rental"
        name="rental"
        label="Yes, I will be renting a firearm today."
        component={ReactMDCheckbox}
        value
      />
      <p className="md-caption md-cell md-cell--12">
        For safety, you must
        have <strong>(2)</strong> people <strong>over 21</strong> to rent a
        firearm.
      </p>

    </section>
    <CardActions>
      <Button
        raised
        label="Save & Continue"
        primary
        className="md-cell--right"
        disabled={submitting || invalid}
        onClick={handleSubmit}
      />
    </CardActions>
  </div>
);

RangeRentalForm.propTypes = {};
RangeRentalForm.defaultProps = {};

export default reduxForm({
  form: "range-rental-form",
  validate: values => {
    if (!values.ranges.pistol && !values.ranges.rifle) {
      return {
        ranges: {
          pistol: "One must be selected",
          rifle: "One must be selected"
        }
      };
    }
  }
})(RangeRentalForm);



// WEBPACK FOOTER //
// ./src/registration/components/RangeRental/RangeRentalForm.jsx